import PropertyTypeFilter from './PropertyTypeFilter';

export default PropertyTypeFilter;
